import { Center, Spinner } from "@chakra-ui/react";
import {
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  LineElement,
  PointElement,
  Title,
  Tooltip,
} from "chart.js";
import { Line } from "react-chartjs-2";
import { useQuery } from "react-query";
import { getStatsActiveReaders } from "../../../services/partnerApi";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend
);

export const options = {
  responsive: true,
  plugins: {
    legend: {
      display: false,
    },
  },
  scales: {
    x: {
      ticks: {
        color: "#FFFFFF",
      },
    },
    y: {
      beginAtZero: true,
      ticks: {
        stepSize: 1,
        precision: 0,
        color: "#FFFFFF",
      },
    },
  },
};

const ActiveReadersChart = () => {
  const { data, isLoading, isError, isSuccess } = useQuery(
    "activeReaders",
    () => {
      return getStatsActiveReaders();
    }
  );

  console.log(data);

  if (isLoading) {
    return (
      <Center p="3">
        <Spinner color="red" />
      </Center>
    );
  }

  if (isError) {
    return <Center p="3">An error ocurred</Center>;
  }

  if (isSuccess && data.data.length === 0) {
    return <Center p="3">No data yet</Center>;
  }

  return (
    <Line
      options={options}
      data={{
        labels: data?.data?.map((item) => item.monthNameYear),
        datasets: [
          {
            label: "Active readers",
            data: data.data.map((item) => item.usersCount),
            borderColor: "#ae1508",
            backgroundColor: "#ae1508",
            color: "#FFFFFF",
          },
        ],
      }}
    />
  );
};

export default ActiveReadersChart;
